export default "query($sku: String!) {\n  product(sku: $sku) {\n    productVariantData {\n      fit\n    }\n  }\n}\n"